<template>
  <div class="mysection">
    <div class="mine_head">
      <img src="../../assets/images/data/img_index_slide_news.jpg" />
      <h4>Wechat Name</h4>
      <a v-on:click="toQuickCode">
        <i class="iconfont right">&#xe642;</i>
        <i class="iconfont qrcode">&#xe693;</i>
      </a>
    </div>
    <div class="mybtn_group">
      <a>普惠借贷<i class="iconfont right">&#xe642;</i></a>
      <a v-on:click="toWxProjectList">借贷大厅<i class="iconfont right">&#xe642;</i></a>
      <a v-on:click="toMyHomePage">我的<i class="iconfont right">&#xe642;</i><span></span></a>
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        uid:'',
      }
    },
    methods:{
      toMyHomePage:function () {
          window.open("https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx3557168303054c37&redirect_uri=http%3a%2f%2fwww.phjd365.com%2fmp&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect");
      },
      toWxProjectList:function () {
        this.$router.push({path:'wxProjectList'})
      },
    },
    mounted(){
      this.$store.dispatch('hideHF');

      var uid=this.$route.query.wuId;
      if(uid){
        this.uid=uid;
      }
    }
  }
</script>
<style slot-scope="scope">
  @import '../../assets/css/wxstyle.css';
</style>



// WEBPACK FOOTER //
// src/components/weChat/WxOfficialAccountTest.vue